import { render, staticRenderFns } from "./self-study.vue?vue&type=template&id=d8fc28c8&scoped=true&"
import script from "./self-study.vue?vue&type=script&lang=js&"
export * from "./self-study.vue?vue&type=script&lang=js&"
import style0 from "./self-study.vue?vue&type=style&index=0&id=d8fc28c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fc28c8",
  null
  
)

export default component.exports